import { useEffect, useState } from 'react';

export function useScreenWidth() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window?.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}
